"use client";

import { motion } from "motion/react";
import { useTranslations } from "next-intl";
import {
    Box,
    Button,
    Link,
    Stack,
    Typography,
    useTheme,
} from "@/components/controls/base-controls";

import {
    HEADER_HEIGHT_FULL,
    WEBPAGE_CORE_CONTAINER,
} from "@/core/constants/webpages";

const Trip = () => {
    const theme = useTheme();
	const t = useTranslations();
    
    return (
        <Stack
            direction="column"
            sx={{
                position: "relative",
                "&::after": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.45)",
                    zIndex: 0,
                },
                "&::before": {
                    content: '""',
                    flexBasis: { xs: "25%", sm: "33%", md: "33%" },
                },
                ...theme.mixins.bgImage({
                    xs: { src: "https://general-images.navairra.com/wing_420x900.png", height: '100svh' },
                    sm: { src: "https://general-images.navairra.com/wing_900x420.png", height: '100svh' },
                    md: { src: "https://general-images.navairra.com/wing_1200x428.png", height: `calc(100svh - ${HEADER_HEIGHT_FULL})` },
                    lg: { src: "https://general-images.navairra.com/wing_1920x680.png", height: `calc(100svh - ${HEADER_HEIGHT_FULL})` },
                    xl: { src: "https://general-images.navairra.com/wing_2538x900.png", height: `calc(100svh - ${HEADER_HEIGHT_FULL})` },
                }),
                height: {
                    xs: '100svh',
                    md: `calc(100vh - ${HEADER_HEIGHT_FULL})`,
                },
                width: "100%"
            }}
        >
            <Box
                component={motion.div} 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                sx={{
                    zIndex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "0 auto",
                    padding: "0 1em",
                    width: WEBPAGE_CORE_CONTAINER,
                    maxWidth: "100%",
                }}
            >
                <Typography
                    variant="h1"
                    sx={{
                        color: "var(--mui-palette-lightest)",
                        lineHeight: 1,
                        textAlign: "center",
                    }}
                >
                    {t("trip.title")}
                </Typography>
            </Box>

            <Button
                variant="link"
                component={Link} 
                sx={{
                    color: "var(--mui-palette-lightest)",                    
                    margin: "5em auto 0",                    
                    zIndex: 1
                }}
                href="/flight-req"
            >
                {t("trip.begin")}
            </Button>
        </Stack>
    );

}

export default Trip;
